// Battery status types used in the UI
export type BatteryStatus = 'CHARGING' | 'DISCHARGING' | 'IDLE' | 'EMPTY' | 'ERROR' | 'OFFLINE';

// This constant controls the threshold for battery power to be considered '0' -- this is to help account for noise
export const BATTERY_UI_THRESHOLD_KW = 0.1;
